import { NAME } from './constants';
import { router } from './router';

export const MontazDV = {
	name: NAME,
	router,
};
